import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

// Async thunk to update category
export const updateCategory = createAsyncThunk(
  "categories/updateCategory",
  async ({ categoryId, categoryData, categoryType }, { rejectWithValue }) => {
    try {
      // Set a default category type in case it's invalid
      const validCategoryTypes = ["quantity", "package", "stock"];
      if (!validCategoryTypes.includes(categoryType)) {
        return rejectWithValue("Invalid category type");
      }

      let endpoint;
      switch (categoryType) {
        case "quantity":
          endpoint = `/Categories/${categoryId}/Update/`;
          break;
        case "package":
          endpoint = `/PackageCategories/${categoryId}/Update/`;
          break;
        case "stock":
          endpoint = `/ProductVouchers/${categoryId}/Update/`;
          break;
        default:
          return rejectWithValue("Invalid category type");
      }

      const response = await axios.patch(`${apiUrl}${endpoint}`, categoryData,  {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      return response.data; // Data returned from the API
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const categoriesSlice = createSlice({
  name: "categories",
  initialState: {
    categories: [],
    isLoading: false,
    error: null,
    updatedCategory: null, // Store the updated category data
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateCategory.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateCategory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.updatedCategory = action.payload;
        state.error = null;
      })
      .addCase(updateCategory.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default categoriesSlice.reducer;
